module.exports = __webpack_public_path__ + "img/bg-coin.d861dbba.svg";